import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import settings from './settings/reducers';
import user from './user/reducers';
import menu from './menu/reducers';
import header from './header/reducers';
import users from './users/reducers';
import workspaces from './workspace/reducers';
import { History } from 'history';
import workspaceusers from "./workspace_users/reducers";
import contactTypes from "./contact_type/reducers";
import addressType from "./address_types/reducers"
import client from "./client/reducers"
import contacts from "./contacts/reducers"
import addresses from "./addresses/reducers"
import attributes from "./attributes/reducers"
import attributesType from "./attributes_types/reducers"
import countries from "./countries/reducers"
import notes from "./notes/reducers"
import consentTypes from "./consent_types/reducers"
import consent from "./consents/reducers"
import employees from "./employees/reducers"
import employeeDocumentTypes from "./employee-document-type/reducers"
import employeeDocuments from "./employee_documents/reducers"
import documents from "./documents/reducers"
import vehicles from "./vehicles/reducers"
import devices from "./devices/reducers"
import customers from "./customers/reducers"
import drivers from "./drivers/reducers"
import customerConfiguration from "./customer_configuration/reducers"
import statistics from "./statistics/reducers"
import vehicleConfiguration from "./vehicle_configuration/reducers"
import exceedingLimits from "./customer_exceeding_limits/reducers"
import customerWorkspace from "./customer_workspace/reducers"
import storedData from "./storedData/reducers"
import ecoDriving from "./ecodriving/reducers"
import invoices from "./invoices/reducers"
import tariffs from "./tariffs/reducers"
import payments from "./payment/reducers"
export default (history: History) => combineReducers({
    router: connectRouter(history),
    settings,
    user,
    menu,
    header,
    users,
    workspaces,
    workspaceusers,
    contactTypes,
    addressType,
    attributesType,
    consentTypes,
    employeeDocumentTypes,
    client,
    contacts,
    addresses,
    attributes,
    countries,
    notes,
    consent,
    employees,
    employeeDocuments,
    documents,
    vehicles,
    devices,
    customers,
    drivers,
    customerConfiguration,
    statistics,
    vehicleConfiguration,
    exceedingLimits,
    storedData,
    customerWorkspace,
    ecoDriving,
    invoices,
    tariffs,
    payments
});
